import React from 'react';
import { useParams } from 'react-router-dom';

import PanelStaffList from '../panels/staff/PanelStaffList';
import PanelStaffAdd from '../panels/staff/PanelStaffAdd';
import PanelStaffInfo from 'panels/staff/PanelStaffInfo';

import PanelDev from '../panels/dev/PanelDev';

export default function LayoutStaff() {

    const { page } = useParams();

    return (
        <div className='h-screen w-full'>
            {
                (() => {
                    switch (page) {
                        case 'staff':
                            return (<PanelStaffList />);
                        case 'staffAdd':
                            return (<PanelStaffAdd />);
                        case 'staffInfo':
                            return (<PanelStaffInfo />);
                        default:
                            return (<PanelDev />);
                    }
                })()
            }
        </div>
    )
}
